module.exports = __webpack_public_path__ + "img/refer-a-friend.4d4eff7c.svg";